import { render, staticRenderFns } from "./IriMap.vue?vue&type=template&id=510e2f75"
import script from "./IriMap.vue?vue&type=script&lang=js"
export * from "./IriMap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports